// bundle related reducers
import { combineReducers } from "redux";
import { reducer as workspaceMenu } from "./WorkspaceMenu";

export default combineReducers({
  workspaceMenu,
});
